import React from 'react';

const StayInTheKnow = () => {
  return (
    <section id="stay-in-the-know" className="stay-in-the-know">
      <h2>STAY IN THE KNOW</h2>
      <p>Join the Fire House crew for new releases and exclusive stories.</p>
      <form className="signup-form">
        <input type="email" placeholder="Your email" />
        <button type="submit" className="btn">Subscribe</button>
      </form>
    </section>
  );
};

export default StayInTheKnow;
